<template>
  <v-container fluid pt-0 pt-md-3>
    <v-card class="mx-auto">
      <v-row no-gutters>
        <v-col sm="3" lg="2" cols="12" class="border-right user-column-left">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                @click.stop="onHomeClicked"
                absolute
                top
                variant="text"
                class="user-back-button"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card flat>
                <v-row justify="center" no-gutters>
                  <v-col cols="12" class="text-center">
                    <v-avatar color="secondary" size="128">
                      <v-icon color="black" size="80">mdi-account</v-icon>
                    </v-avatar>
                  </v-col>
                </v-row>
                <v-card-subtitle class="text-wrap">
                  <div class="text-center text-overline mb-0">
                    {{ loggedInUser.roleName }}
                  </div>
                  <div class="text-center text-h6 text-primary text-break">
                    {{ loggedInUser.email }}
                  </div>
                </v-card-subtitle>
              </v-card>
              <v-card-text class="pa-0">
                <v-divider></v-divider>
                <v-list class="px-0 pt-0 pb-4 user-view-list-nav">
                  <v-list-item
                    router
                    density="compact"
                    active-class="bg-secondary user-view-active-item"
                    :to="{ name: 'userAccountProfile' }"
                  >
                    <template v-slot:prepend>
                      <v-icon color="accent">mdi-card-account-details</v-icon>
                    </template>
                    <v-list-item-title class="text-capitalize">
                      {{ $t("users.settings.menuItems.profile") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    router
                    density="compact"
                    active-class="bg-secondary user-view-active-item"
                    :to="{ name: 'userAccountSettings' }"
                  >
                    <template v-slot:prepend>
                      <v-icon color="accent">mdi-cog</v-icon>
                    </template>
                    <v-list-item-title class="text-capitalize">
                      {{ $t("users.settings.menuItems.settings") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-col>
          </v-row>
        </v-col>

        <v-col sm="9" lg="10" cols="12">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser
    }
  },
  methods: {
    onHomeClicked() {
      this.$router.push("/home")
    }
  }
}
</script>

<style type="scss">
/* Vuetify's default prepend-to-title spacer is too wide for this compact nav. */
.user-view-list-nav .v-list-item__prepend > .v-icon ~ .v-list-item__spacer {
  width: 8px;
}
/* The active-class already swaps in the yellow background; the built-in
   activated overlay would additionally darken it on top of that. */
.user-view-list-nav .v-list-item--active > .v-list-item__overlay {
  opacity: 0 !important;
}
</style>
